<template>
  <b-modal ref="groupingEditModal" :title="$t('modal_dialogs.group')">
    <b-row>
      <b-col offset="2" cols="8">
        <label>{{$t('labels.common.thickness')}}</label>
        <options-toggle-multiselect :data.sync="groupingData.thickness" :options="optionsData.thickness"
                                    :toggle-cb="fetchOptionsData">
          <multiselect v-model="groupingData.thickness" :max-height="200"
                       placeholder="" :options="optionsData.thickness"
                       :multiple="true" :close-on-select="false"
                       @close="fetchOptionsData" @remove="fetchOptionsData"
                       :class="{ required: !groupingData.thickness || !groupingData.thickness.length}">
          </multiselect>
        </options-toggle-multiselect>
      </b-col>
    </b-row>
    <b-row>
      <b-col offset="2" cols="8">
        <label>{{$t('labels.common.width')}}</label>
        <options-toggle-multiselect :data.sync="groupingData.width" :options="optionsData.width"
                                    :is-disabled='!groupingData.thickness || !groupingData.thickness.length'
                                    :toggle-cb="fetchOptionsData">
          <multiselect v-model="groupingData.width" :max-height="200"
                       placeholder="" :options="optionsData.width"
                       :multiple="true" :close-on-select="false"
                       :disabled="!groupingData.thickness || !groupingData.thickness.length"
                       @close="fetchOptionsData" @remove="fetchOptionsData"
                       :class="{ required: !groupingData.width || !groupingData.width.length}">
          </multiselect>
        </options-toggle-multiselect>
      </b-col>
    </b-row>
    <b-row>
      <b-col offset="2" cols="8">
        <label>{{$t('labels.common.length')}}</label>
        <options-toggle-multiselect :data.sync="groupingData.length" :options="optionsData.length"
                                    :is-disabled='!groupingData.thickness || !groupingData.thickness.length'
                                    :toggle-cb="fetchOptionsData">
          <multiselect v-model="groupingData.length" :max-height="200"
                       placeholder="" :options="optionsData.length" :multiple="true"
                       :disabled="!groupingData.thickness || !groupingData.thickness.length"
                       @close="fetchOptionsData" @remove="fetchOptionsData" :close-on-select="false"
                       :class="{ required: !groupingData.length || !groupingData.length.length}">
          </multiselect>
        </options-toggle-multiselect>
      </b-col>
    </b-row>
    <b-row>
      <b-col offset="2" cols="8">
        <label>{{$t('labels.common.quality')}}</label>
        <options-toggle-multiselect :data.sync="groupingData.quality" :options="optionsData.quality"
                                    :is-disabled='!groupingData.thickness || !groupingData.thickness.length'
                                    :toggle-cb="fetchOptionsData">
          <multiselect v-model="groupingData.quality" :max-height="200" label="name" track-by="name"
                       placeholder="" :options="optionsData.quality" :multiple="true"
                       :disabled="!groupingData.thickness || !groupingData.thickness.length"
                       @close="fetchOptionsData" @remove="fetchOptionsData" :close-on-select="false"
                       :class="{ required: !groupingData.quality || !groupingData.quality.length}">
          </multiselect>
        </options-toggle-multiselect>
      </b-col>
    </b-row>
    <div slot="modal-footer" class="w-100 text-center">
      <b-btn size="sm" variant="success" @click="saveGrouping" title="Save grouping">
        {{$t('buttons.common.save')}}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import OptionsToggleMultiselect from '@/components/common/OptionsToggleMultiselect';
  import { handlerResponse, getArrayByProperty, setNotifyData } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';

  export default {
    props: ['operationId', 'fetchCallback'],
    components: {
      Multiselect, OptionsToggleMultiselect
    },
    data() {
      return {
        initialGroupingData: {thickness: [], width: [], length: [], quality: []}, groupingData: {}, optionsData: {
          thickness: [], width: [], length: [], quality: []
        }
      }
    },
    methods: {
      async fetchOptionsData() {
        const params = {
          thickness: this.groupingData.thickness.toString(),
          width: this.groupingData.width.toString(),
          length: this.groupingData.length.toString(),
          quality: getArrayByProperty(this.groupingData.quality, 'id').toString()
        };
        try {
          this.optionsData = await this.$http.get(`woodware/movement_group_data_for_creating/${this.operationId}/`, {params}).then(handlerResponse);
        } catch (e) {
          console.log(e);
        }
      },
      saveGrouping() {
        const loader = this.$loading.show();
        const payload = {
          thickness: this.groupingData.thickness,
          width: this.groupingData.width,
          length: this.groupingData.length,
          quality: getArrayByProperty(this.groupingData.quality, 'id'),
          movement: this.operationId
        };
        if (this.groupingData.isNew) {
          this.$http.post(`woodware/movement_groups/`, payload).then(() => {
            this.$refs['groupingEditModal'].hide();
            this.$notify(setNotifyData('Success', 'Grouping has been added!', 'success'));
            this.$store.dispatch('operation/loadOperationGroups', this.operationId);
            this.fetchCallback();
            loader.hide();
          }).catch(error => {
            notificationsRenderer(error.data, 'error');
            loader.hide();
          });
        } else {
          const groupingId = this.groupingData.id;
          this.$http.put(`woodware/movement_groups/${groupingId}/`, payload).then(() => {
            this.$refs['groupingEditModal'].hide();
            this.$notify(setNotifyData('Success', 'Grouping has been updated!', 'success'));
            this.$store.dispatch('operation/loadOperationGroups', this.operationId);
            this.fetchCallback();
            loader.hide();
          }).catch(error => {
            notificationsRenderer(error.data, 'error');
            loader.hide();
          });
        }
      }
    },
    mounted() {
      this.$root.$on('openEditGroupingModal', async (data) => {
        this.groupingData = {...this.initialGroupingData};
        this.groupingData = {...this.initialGroupingData, ...data};
        await this.fetchOptionsData();
        if (this.$refs['groupingEditModal']) {
          this.$refs['groupingEditModal'].show();
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('openEditGroupingModal');
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/GroupingEditModal.vue